import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/minus.svg'
import _imports_1 from '../../assets/caprock/images/plus.svg'
import _imports_2 from '../../assets/caprock/images/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-17a02e83"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = { class: "row my-3 justify-content-center" }
const _hoisted_3 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_4 = { class: "login-card" }
const _hoisted_5 = { class: "login-body company" }
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = { class: "col-md-12 col-12" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { style: {"color":"grey","font-family":"'Merriweather'"} }
const _hoisted_10 = { class: "col-md-12 col-12" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_13 = { class: "col-md-12 col-12" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Address", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile mt-3 btn-mobile font-size-15-18"
  }, " Save Owner ")
], -1))
const _hoisted_17 = {
  key: 1,
  class: "row my-3 justify-content-center"
}
const _hoisted_18 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_19 = { class: "login-card" }
const _hoisted_20 = { class: "login-body company" }
const _hoisted_21 = { class: "row mt-3" }
const _hoisted_22 = { class: "col-md-12 col-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { style: {"color":"grey","font-family":"'Merriweather'"} }
const _hoisted_25 = { class: "col-md-12 col-12 table-responsive" }
const _hoisted_26 = { class: "table table-bordered w-100" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Address"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_2
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "No records found", -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.owners.length==0 || _ctx.show_form==1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          ref: "owner_form",
          id: "owner_form",
          method: "POST",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.save_owner
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h4", _hoisted_9, [
                            _createTextVNode(" Add Owner "),
                            (_ctx.owners.length>0)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.show_form=0)),
                                  style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                  src: _imports_0
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.owner_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.owner_name) = $event)),
                            placeholder: "i.e. Jonaten ",
                            class: "form-control selected-field",
                            name: "owner_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "owner_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.owner_address,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.owner_address) = $event)),
                            placeholder: "i.e. Sydney West  ",
                            class: "form-control selected-field",
                            name: "owner_address",
                            type: "text",
                            rules: [_ctx.requiredField]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "owner_address"
                          })
                        ])
                      ]),
                      _hoisted_16
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.owners.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h4", _hoisted_24, [
                        _createTextVNode(" Beneficial Owners "),
                        _createElementVNode("img", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (this.show_form=1)),
                          style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                          src: _imports_1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.owners, (owner, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: owner.owner_id
                          }, [
                            _createElementVNode("td", _hoisted_28, _toDisplayString(index+1), 1),
                            _createElementVNode("td", null, _toDisplayString(owner['owner_name']), 1),
                            _createElementVNode("td", null, _toDisplayString(owner['owner_address']), 1),
                            _createElementVNode("td", _hoisted_29, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => {_ctx.delete_owner(owner.owner_id);},
                                class: "btn-mobile btn"
                              }, _hoisted_32, 8, _hoisted_30)
                            ])
                          ]))
                        }), 128)),
                        (!_ctx.owners.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_33, _hoisted_35))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}